import { initialConversations, initialJobs, type Opening, type BoardJob, type Conversation } from './mock/data'

export type Workspace = {
  jobs: BoardJob[]
  conversations: Conversation[]
  follows: Set<string>
  read: Set<string>
}

export function createWorkspace(): Workspace {
  return {
    jobs: structuredClone(initialJobs),
    conversations: structuredClone(initialConversations),
    follows: new Set(['Ramp', 'Stripe', 'Linear']),
    read: new Set(['linear-product'])
  }
}

export function saveOpening(workspace: Workspace, opening: Opening): void {
  if (workspace.jobs.some((job) => job.id === opening.id)) return
  workspace.jobs.push({ ...opening, stage: 'interested', saved: 'Just now', notes: '', interviews: [], offer: null })
}

export type PreviewActions = {
  changed: () => void
  report: (message: string) => void
  show: (page: string) => void
}
